const GTM_HANDLES = {
  shared: {
    stopNavigationButton: 'stop-navigation-button',
    favoriteRemoved: 'favorite-removed',
    favoriteAdded: 'favorite-added',
    systemWideAlertButton: 'system-wide-alert-button',
    trackerRefreshButton: 'tracker-refresh-button',
  },
  home: {
    searchInputButton: 'search-input-button',
    trackerTab: 'tracker-tab',
    plannerTab: 'planner-tab',
    routesTab: 'routes-tab',
    alertsTab: 'alerts-tab',
    searchByStopIdButton: 'search-by-stop-id-button',
    trackerNearbyStops: 'tracker-nearby-stops',
  },
  stop: {
    stopDetailTripButtonGoHere: 'stop-detail-trip-button-go-here',
    stopScheduleLink: 'stop-schedule-link',
    stopDetailTripButtonStartHere: 'stop-detail-trip-button-start-here',
    fullScheduleLink: 'full-schedule-link',
    arrivalButton: 'arrival-button',
    stopDetailRouteAlertsButton: 'stop-detail-route-alerts-button',
    stopDetailRouteExpansionButton: 'stop-detail-route-expansion-button',
    stopAlertMoreLink: 'stop-alert-more-link',
    stopLeaveFeedbackLink: 'stop-leave-feedback-link',
    stopAmenitiesButton: 'stop-amenities-button',
  },
  vehicle: {
    vehicleStopMapButton: 'vehicle-stop-map-button',
  },
  routeList: {
    routeButton: 'route-button',
    routeListAlertsButton: 'route-list-alerts-button',
    routeSearchInput: 'route-search-input',
  },
  route: {
    routeAlertsPreviewButton: 'route-alerts-preview-button',
    fullRouteDetailsButton: 'full-route-details-button',
    routeDirectionButton: 'route-direction-button',
    routeAlertsByEmailButton: 'route-alerts-by-email-button',
    stopDetailButton: 'stop-detail-button',
  },
  tripRequest: {
    swapEndpointsButton: 'trip-request-swap-endpoints-button',
    endpointFrom: 'trip-request-endpoint-from',
    endpointTo: 'trip-request-endpoint-to',
    dateTimeButton: 'trip-request-date-time-button',
    travelOptionsButton: 'trip-request-travel-options-button',
    planTripButton: 'trip-request-plan-trip-button',
  },
  dateTimeSettings: {
    planTripButton: 'date-time-settings-get-directions-button',
    saveSettingsButton: 'date-time-settings-save-settings-button',
    editButton: 'date-time-settings-edit-button',
  },
  tripModeSettings: {
    planTripButton: 'trip-mode-plan-trip-button',
    saveSettingsButton: 'trip-mode-save-settings-button',
  },
  itinerary: {
    tripOptionTab: 'itinerary-trip-option-tab',
    footerFeedbackButton: 'itinerary-footer-feedback-button',
    footerPrintButton: 'itinerary-footer-print-button',
    footerShareButton: 'itinerary-footer-share-button',
    footerCalendarButton: 'itinerary-footer-calendar-button',
    footerCopyButton: 'itinerary-footer-copy-button',
    footerServiceAlertsButton: 'itinerary-footer-service-alerts-button',
    footerEditErrorTripLink: 'itinerary-footer-error-edit-trip-link',
    arrivalTimeLink: 'itinerary-arrival-time-link',
  },
  location: {
    locationDetailTripButtonGoHere: 'location-detail-trip-button-go-here',
    locationDetailTripButtonStartHere: 'location-detail-trip-button-start-here',
    locationZoom: 'location-zoom-button',
    locationDetailNearbyStops: 'location-detail-nearby-stops',
  },
  alertsList: {
    globalMoreLink: 'alerts-list-global-more-link',
    routeButton: 'alerts-list-route-button',
  },
  routeAlerts: {
    emailSignupButton: 'route-alerts-email-signup-button',
    moreLink: 'route-alerts-more-link',
  },
  omnibox: {
    searchFavoriteButton: 'omnibox-search-favorite-button',
    searchRecentButton: 'omnibox-search-recent-button',
    searchNearbyButton: 'omnibox-search-nearby-button',
  },
  layerButton: {
    themes: 'layer-button-themes',
    mapTiles: 'layer-button-map-tiles',
    transit: 'layer-button-transit',
    bikes: 'layer-button-bikes',
    scooters: 'layer-button-scooters',
    car: 'layer-button-car',
  },
  nav: {
    securityButton: 'nav-security-button',
    logoButton: 'nav-logo-button',
    menuOpenButton: 'nav-menu-open-button',
    riderNewsButton: 'nav-menu-rider-news-button',
    promoButton: 'nav-menu-promo-button',
    omniboxButton: 'search-input-button',
  },
  menu: {
    modeLinkBus: 'menu-mode-link-bus',
    modeLinkMax: 'menu-mode-link-max',
    modeLinkWes: 'menu-mode-link-wes',
    modeLinkLift: 'menu-mode-link-lift',
    logoLink: 'menu-logo-link',
    closeLink: 'menu-close-link',
    primaryMenuItem: 'menu-primary-item',
    secondaryMenuItem: 'menu-secondary-item',
    modeLinkStreetcar: 'menu-mode-link-streetcar',
    imageLink: 'menu-image-link',
    linkBetaFeedback: 'menu-link-beta-feedback',
    linkHopFares: 'menu-link-hop-fares',
    linkSchedules: 'menu-link-schedules',
    linkHowToRide: 'menu-link-how-to-ride',
    linkNews: 'menu-link-news',
    linkRidersClub: 'menu-link-riders-club',
    linkRidersClubJoin: 'menu-link-riders-club-join',
    linkBlog: 'menu-link-blog',
    linkGearStore: 'menu-link-gear-store',
    linkCustomerService: 'menu-link-customer-service',
    linkLostAndFound: 'menu-link-lost-and-found',
    linkLeaveFeedback: 'menu-link-leave-feedback',
    linkEmailSmsServiceUpdates: 'menu-link-email-sms-service-updates',
    linkEmailSmsManageAccount: 'menu-link-email-sms-manage-account',
    linkAbout: 'menu-link-about',
    linkCareers: 'menu-link-careers',
    linkSwitchSite: 'menu-link-switch',
    buttonSearch: 'menu-button-search',
    privacyPolicy: 'menu-button-privacy-policy',
    termsOfUse: 'menu-button-terms-use',
  },
  map: {
    settingsButton: 'map-layers-button',
    currentLocationButton: 'map-current-location-button',
    zoomInButton: 'map-zoom-in-button',
    zoomOutButton: 'map-zoom-out-button',
    resetRotationButton: 'map-reset-rotation-button',
    toggle3DButton: 'map-toggle-3d-button',
    contextClearCurrentLocation: 'context-menu-clear-current-location',
    contextSetCurrentLocation: 'context-menu-set-current-location',
    contextSeeNearbyService: 'context-menu-see-nearby-service',
    contextGoHere: 'context-menu-go-here',
    contextStartHere: 'context-menu-start-here',
    showExtraMapControlsOnMobile: 'always-show-map-controls',
  },
  pay: {
    linkPhone: 'pay-link-phone',
    linkHopcard: 'pay-link-hopcard',
    linkContactless: 'pay-link-contactless',
    linkCash: 'pay-link-cash',
  },
};

export default GTM_HANDLES;
